import { render, staticRenderFns } from "./index.vue?vue&type=template&id=05bb62d4"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/185/185admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05bb62d4')) {
      api.createRecord('05bb62d4', component.options)
    } else {
      api.reload('05bb62d4', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=05bb62d4", function () {
      api.rerender('05bb62d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customer/customer-source/index.vue"
export default component.exports